import { NEW_NOTIFICATION, UPDATE_NOTIFICATION } from './../constants';
import { handleActions } from "redux-actions"

export const notifications  = handleActions(
  {
    [ NEW_NOTIFICATION ]: (state, action) =>  [...state, action.payload ],
    [ UPDATE_NOTIFICATION ]: (state, action) => {
      const initialValue = []
      const newNotification = state.reduce((acc, notification) => {
        // console.log('compara ', notification.id, '===', action.payload.id, acc)
          if (notification.id === action.payload.id) {
            // console.log('encuantra')
              return [...acc, action.payload]
          } else {
            // console.log('no encuadra', acc, notification)
              return [...acc, notification]
          }
      }, initialValue)
      if (newNotification.length === 0){
        return [action.payload]
      }
      return newNotification
    }
  }, []
)